<template>
    <div>
        <div class="card" :class="cardClass">
            <div class="card-body">
                <h2 v-if="heading !== ''">{{ heading }}</h2>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        heading: {
            type: String,
            default: ''
        },
        cardClass: {
            type: String,
            default: ''
        }
    }
}
</script>
